module.exports = __webpack_public_path__ + "img/0-view.01fcca16.png";